import { User } from '@models/user.model';
import { custom, deserialize, serializable } from 'serializr';
import { Base } from '../../../models/base.model';
import { PageObject } from '../../../models/page-object.model';
import { immerable } from 'immer';

export class Environment extends Base implements PageObject {
  [immerable] = true;
  @serializable
  public name: string;
  @serializable
  public description: string;
  @serializable
  public createdById: number;
  @serializable
  public updatedById: number;
  @serializable(
    custom(
      (v) => v,
      (v) => v,
    ),
  )
  public variables: JSON;

  public createdBy: User;
  public updatedBy: User;
  public projectId: number;
  public totalElements: number;
  @serializable(
    custom(
      (v) => v,
      (v) => v,
    ),
  )
  public passwords: string[];

  @serializable(
    custom(
      (v) => v,
      (v) => v,
    ),
  )
  public encryptionIgnoreList: string[];

  deserialize(input: any): this {
    return Object.assign(this, deserialize(Environment, input));
  }
}
